/* tslint:disable */
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { WebConfiguration, WebConfigurationInterface } from './web-configuration';

import { FinanceService } from './services/finance.service';
import { LoginService } from './services/login.service';
import { LogisticsService } from './services/logistics.service';
import { DeliveryDocumentsService } from './services/delivery-documents.service';
import { PreInvoiceService } from './services/pre-invoice.service';
import { TerminalsService } from './services/terminals.service';
import { StationsService } from './services/stations.service';
import { TanksService } from './services/tanks.service';
import { TankSecurityDocumentsService } from './services/tank-security-documents.service';
import { UsersService } from './services/users.service';
import { ClientsService } from './services/clients.service';
import { CarriersService } from './services/carriers.service';
import { SettingsService } from './services/settings.service';

/**
 * Provider for all Web services, plus WebConfiguration
 */
@NgModule({
  imports: [
    HttpClientModule
  ],
  exports: [
    HttpClientModule
  ],
  declarations: [],
  providers: [
    WebConfiguration,
    FinanceService,
    LoginService,
    LogisticsService,
    DeliveryDocumentsService,
    PreInvoiceService,
    TerminalsService,
    StationsService,
    TanksService,
    TankSecurityDocumentsService,
    UsersService,
    ClientsService,
    CarriersService,
    SettingsService
  ],
})
export class WebModule {
  static forRoot(customParams: WebConfigurationInterface): ModuleWithProviders<WebModule> {
    return {
      ngModule: WebModule,
      providers: [
        {
          provide: WebConfiguration,
          useValue: {rootUrl: customParams.rootUrl}
        }
      ]
    }
  }
}
